import { defineMessages } from "react-intl";

export default defineMessages({
  cardHolder: {
    id: "creditCardPreview.cardHolder",
    defaultMessage: "Card holder",
  },
  cardNumber: {
    id: "creditCardPreview.cardNumber",
    defaultMessage: "Card number",
  },
  expirationDate: {
    id: "creditCardPreview.expirationDate",
    defaultMessage: "Expiration date",
  },
  modifyCard: {
    id: "creditCardPreview.modifyCard",
    defaultMessage: "Modify card",
  },
  submit: {
    id: "creditCardPreview.submit",
    defaultMessage: "Submit",
  },
  paymentOnWebsite: {
    id: "creditCardPreview.paymentOnWebsite",
    defaultMessage:
      "Payment <bold>after the service</bold> on Ring Twice website. Reminder: pay the service provider directly is not allowed.",
  },
});
